import network from "../network";
import settings from "../network/settings";

const routes = {
  login: "/auth/login",
  loginAdmin: "/auth/login/admin", 
  logout: "/auth/logout",
  activate: "/auth/activate",
  reset: "/auth/reset",
  changePassword: "/auth/change-password",
  setupPassword: "/auth/setup-password",
  forgotPassword: "/auth/forgot",
  resetPassword: "/auth/reset",

  checkToken: "/user/session",
  availableAudits: "/edit/audits",
  audit: "/edit/audit",
  // premises: "/user/premises", // DEPRECATED - Use BASE_PREMISES instead
  render: "/edit/render/",
  sections: '/categories',

  progress: "/audit/progress",

  submitAudit: "/edit/audit",
  submitImage: "/audit/image",
  submitEditImage: "/edit/image",
  deleteParsedAudit: "/edit/audit/",
  question: '/questions',
  category: '/categories',
  template: '/templates',

  log: "/user/clientlog",

  BASE_PREMISES: "/premises",
  GROUPS: "/premises/groups",
  ORGANIZATIONS: "/premises/organizations",
  USERS: "/user/users",
  USERAUDITS: "/user/audits",
  MANAGERS: "/user/managers",
  USER: "/user",
  TEMPLATES: "/templates",
  ROLES: "/roles",
  REPORTS: "/reports",

};

const makeAuthConf = function (token) {
  return {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
};

const APILog = (message) => {}; // Silenced for cleaner console output
const APINetLog = (message) => {}; // Silenced for cleaner console output

// Checks response status and fetches error messages
const APINetCheck = function (r) {
  return new Promise(function (resolve, reject) {
    r.status >= 500
      ? reject(new Error("Server Error")) || APINetLog("Server error...")
      : r.status >= 400
        ? reject(new Error(r.data.message)) || APINetLog("API error...")
        : r.status >= 200
          ? resolve(r) || APINetLog("OK...")
          : reject(new Error("Unknown Error (?)")) || APINetLog("Unknown error...");
  });
};

// APILog("Service loaded - base URL: " + settings.API_URL); // Silenced for cleaner console output

export default {
  makeAuthConf,
  APILog,
  login: function (username, password, isGoogle = false) {
    if (isGoogle) {
      const params = new URLSearchParams();
      params.append("username", username);
      params.append("password", password);
      
      return network.post(routes.loginAdmin, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    }
    
    APILog(`Attempting login as [${username}]...`);
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);

    return network.post(routes.loginAdmin, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }).then(APINetCheck);
  },
  // login: function(username, password) {
  //   APILog("Attempting login as [" + username + "]...");
  //   return network
  //     .post(routes.login, { username, password })
  //     .then(APINetCheck);
  // },
  checkToken: function (token) {
    APILog("Validating previous session token...");
    return network
      .get(routes.checkToken, makeAuthConf(token))
      .then(APINetCheck);
  },
  logout: function (token) {
    APILog("Attempting logout...");
    return network.get(routes.logout, makeAuthConf(token)).then(APINetCheck);
  },
  getPremises: function (token) {
    APILog("Fetching all premises...");
    return network.get(routes.BASE_PREMISES + "/asc", makeAuthConf(token)).then(APINetCheck);
  },
  getAudits: function (token, currentPage, perPage, sortBy, sortDirection, filters = {}) {
    APILog("Fetching available audit templates...");
    
    const params = new URLSearchParams({
      currentPage,
      perPage,
      sortBy,
      sortDirection
    });
    
    // Add filter parameters if they exist
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.premise) params.append('premise', filters.premise);
    if (filters.templateName) params.append('templateName', filters.templateName);
    if (filters.auditor) params.append('auditor', filters.auditor);
    
    const finalUrl = `${routes.availableAudits}?${params.toString()}`;
    console.log('Final URL being called:', finalUrl);
    console.log('Full URL with base:', `${settings.API_URL}${finalUrl}`);
    
    return network
      .get(finalUrl, makeAuthConf(token))
      .then(APINetCheck);
  },
  getAudit: function (token, templateId) {
    APILog(`Fetching audit template [${templateId}]...`);
    return network
      .get(routes.audit + "/" + templateId, makeAuthConf(token))
      .then(APINetCheck);
  },
  getSections: function (token, templateId) {
    APILog(`Fetching audit template [${templateId}]...`);
    return network
      .get(`${routes.sections}/${templateId}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  renderReport: function (token, auditUuid) {
    APILog(`Render audit report with audit uuid [${auditUuid}]...`);
    return network
      .get(routes.render + auditUuid, makeAuthConf(token))
      .then(APINetCheck);
  },
  submitAudit: function (token, auditUuid, auditBody) {
    APILog(
      `Submitting audit "${auditBody.name}" for [${auditBody.location}]...`
    );
    return network
      .post(
        `${routes.submitAudit}/${auditUuid}`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },
  submitImage: function (token, parsed_audit, location, question, image) {
    APILog(`Submitting audit image...`);
    let conf = makeAuthConf(token);

    return network
      .post(
        `${routes.submitEditImage}/${parsed_audit}/${location}/${question}`,
        { data: image },
        conf
      )
      .then(APINetCheck);
  },
  activate: function (token) {
    APILog("Activating account...");
    return network.get(`${routes.activate}/${token}`).then(APINetCheck);
  },
  reset: function (token, password, confirm) {
    APILog("Resetting password...");
    return network
      .post(routes.reset, { token, password, confirm })
      .then(APINetCheck);
  },
  
  changePassword: function (token, currentPassword, newPassword, confirmPassword) {
    APILog("Changing password for authenticated user...");
    return network
      .post(routes.changePassword, { 
        current_password: currentPassword, 
        new_password: newPassword, 
        confirm_password: confirmPassword 
      }, makeAuthConf(token))
      .then(APINetCheck);
  },
  
  setupPassword: function (invitationToken, password, confirmPassword) {
    APILog("Setting up password for new user...");
    return network
      .post(routes.setupPassword, { 
        token: invitationToken, 
        password: password, 
        confirm_password: confirmPassword 
      })
      .then(APINetCheck);
  },
  
  forgotPassword: function (email) {
    APILog("Requesting password reset...");
    return network
      .post(routes.forgotPassword, { email: email })
      .then(APINetCheck);
  },
  
  resetPassword: function (resetToken, password, confirm) {
    APILog("Resetting password with token...");
    return network
      .post(routes.resetPassword, { 
        token: resetToken, 
        password: password, 
        confirm: confirm 
      })
      .then(APINetCheck);
  },
  log: function (token, data) {
    APILog("Logging a state...");
    // console.log(data); // Silenced for cleaner console output
    return network
      .post(routes.log, data, makeAuthConf(token))
      .then(APINetCheck);
  },
  deleteParsedAudit: function (token, parsedUuid) {
    APILog("Deleting parsed audit");
    return network.delete(`${routes.deleteParsedAudit}${parsedUuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_premises: function (token) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.BASE_PREMISES, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_premises_sort: function (token, sort) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.BASE_PREMISES + "/" + sort, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_premises_paginated: function(token, currentPage, perPage, sortBy, sortDirection, name, groupName) {
    APILog("Fetching paginated premises...");
    
    let params = new URLSearchParams({
      currentPage,
      perPage,
      sortBy,
      sortDirection
    });
    
    if (name) params.append('name', name);
    if (groupName) params.append('group_name', groupName);
    
    return network
      .get(`${routes.BASE_PREMISES}?${params.toString()}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_premises: function (token, data) {
    APILog("Fetching all available locations...");
    return network
      .post(routes.BASE_PREMISES, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_premises: function (token, uuid) {
    APILog("Deleting parsed audit");
    return network.delete(`${routes.BASE_PREMISES}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_premises(token, uuid, data) {
    APILog("Deleting parsed audit");
    return network.put(`${routes.BASE_PREMISES}/${uuid}`, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_premises_group: function (token, data) {
    APILog("Fetching all available locations...");
    return network
      .post(routes.GROUPS, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_premises_group: function (token, uuid) {
    APILog("Deleting parsed audit");
    return network.delete(`${routes.GROUPS}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_premises_group(token, uuid, data) {
    APILog("Deleting parsed audit");
    return network.put(`${routes.GROUPS}/${uuid}`, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_premises_organization: function (token, data) {
    APILog("Fetching all available locations...");
    return network
      .post(routes.ORGANIZATIONS, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_premises_organization: function (token, uuid) {
    APILog("Deleting parsed audit");
    return network.delete(`${routes.ORGANIZATIONS}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_premises_organization(token, uuid, data) {
    APILog("Deleting parsed audit");
    return network.put(`${routes.ORGANIZATIONS}/${uuid}`, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_groups: function (token) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.GROUPS, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_groups_sort: function (token, sort) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.GROUPS + "/" + sort, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_organizations: function (token) {
    APILog("Fetching all available organizations...");
    return network
      .get(routes.ORGANIZATIONS, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_organizations_sort: function (token, sort) {
    APILog("Fetching all available organizations...");
    return network
      .get(routes.ORGANIZATIONS + "/" + sort, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_templates: function (token, page = 1, perPage = 15, search = null) {
    APILog("Fetching all available templates...");

    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString()
    });

    if (search) {
      params.append('search', search);
    }

    return network
      .get(`${routes.TEMPLATES}?${params.toString()}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_user_templates: function (token, targetUserId, page = 1, perPage = 15) {
    APILog(`Fetching templates for user ${targetUserId}...`);
    return network
      .get(`${routes.TEMPLATES}/user/${targetUserId}?page=${page}&per_page=${perPage}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_template: function (token, data) {
    APILog("Creating a new template...");
    return network
      .post(routes.TEMPLATES, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_template: function (token, uuid, data) {
    APILog(`Updating template ${uuid}...`);
    return network
      .put(`${routes.TEMPLATES}/${uuid}`, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_template: function (token, uuid) {
    APILog(`Deleting template ${uuid}...`);
    return network
      .delete(`${routes.TEMPLATES}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_users: function (token) {
    APILog("Fetching all available users...");
    return network
      .get(routes.USERS, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_managers: function (token) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.MANAGERS, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_users_sort: function(token, organization, currentPage, perPage, sortBy, sortDirection, name, email) {
    APILog("Fetching all available locations...");
    
    let params = new URLSearchParams({
      currentPage,
      perPage,
      sortBy,
      sortDirection
    });
    
    if (organization) params.append('organization', organization);
    if (name) params.append('name', name);
    if (email) params.append('email', email);
    
    return network
      .get(`${routes.USERS}?${params.toString()}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_audits: function (token) {
    APILog("Fetching all available audits...");
    return network
      .get(routes.USERAUDITS, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_user: function (token, data) {
    APILog("Fetching all available locations...");
    return network
      .post(routes.USER, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_question: function (token, formData) {
    APILog("Creating a question...");
    // Accept FormData for multipart/form-data support with images
    const config = makeAuthConf(token);
    if (formData instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return network
      .post(routes.question, formData, config)
      .then(APINetCheck);
  },

  update_question: function (token, uuid, formData) {
    APILog("Updating a question");
    // Accept FormData for multipart/form-data support with images
    const config = makeAuthConf(token);
    if (formData instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return network
      .put(`${routes.question}/${uuid} `, formData, config)
      .then(APINetCheck);
  },

  delete_question: function(token, uuid) {
    APILog("Deleting a question");
    return network.delete(`${routes.question}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  create_category: function (token, uuid, data) {
    APILog("Creating a category");
    return network
      .post(`${routes.category}/${uuid}`, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_category: function (token, uuid, data) {
    APILog("Updating a category");
    return network
      .put(`${routes.category}/${uuid} `, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_category: function(token, uuid) {
    APILog("Deleting a category");
    return network.delete(`${routes.category}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  update_user: function (uuid, token, data) {
    APILog("Fetching all available locations...");
    return network
      .post(`${routes.USER}/${uuid} `, data, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_roles: function (token) {
    APILog("Fetching all available locations...");
    return network
      .get(routes.ROLES, makeAuthConf(token))
      .then(APINetCheck);
  },

  delete_user: function(token, uuid) {
    APILog("Deleting a user");
    return network.delete(`${routes.USER}/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_user_details(token, uuid) {
    APILog("Fetching a user details with uuid " + uuid)

    return network.get(`${routes.USER}/details/${uuid}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_generic_report_data(token, params) {
    APILog("Fetching a generic reports data")

    return network.get(`${routes.DASHBOARD_MONTHLY}ic?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_location_monthly_data(token, params) {
    APILog("Fetching a location monthly data in dashboard")

    return network.get(`${routes.REPORTS}/dashboard/location_monthly_scores?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_number_of_audits_submitted(token, params) {
    APILog("Fetching a total audits data")

    return network.get(`${routes.REPORTS}/dashboard/totalaudits?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },

  fetch_dashboard_average_score(token, params) {
    APILog("Fetching a average score data")

    return network.get(`${routes.REPORTS}/dashboard/averagescore?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_location_performance(token, params) {
    APILog("Fetching a location performance data")

    return network.get(`${routes.REPORTS}/dashboard/location_performance?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_section_performance_aggregated(token, params) {
    APILog("Fetching a section performance aggregated data")

    return network.get(`${routes.REPORTS}/dashboard/section_performance_aggregated?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_question_performance_aggregated(token, params) {
    APILog("Fetching a question performance aggregated data")

    return network.get(`${routes.REPORTS}/dashboard/question_performance_aggregated?${params}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  generate_pdf_and_send(token, uuid,download) {
    APILog("Fetching a generic reports data")

    return network.get(`${routes.render}${uuid}${download ? "?download_only=true" : ""}`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_premises_by_template(token, templateUuid) {
    APILog("Fetching a question performance aggregated data")

    return network.get(`${routes.REPORTS}/${templateUuid}/premises`, makeAuthConf(token))
      .then(APINetCheck);
  },
  fetch_dashboard_total_audits(token, fromDate,toDate,templateUuid,locationUuids,premisesGroupUuid) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid,
      premisesGroupUuid
    };

    return network
      .post(
        `${routes.REPORTS}/dashboard/totalaudits`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },
  fetch_dashboard_average_audit_score(token, fromDate,toDate,templateUuid,locationUuids,premisesGroupUuid,download) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid,
      premisesGroupUuid
    };

    const config = {
      ...makeAuthConf(token),
      headers: {
        ...makeAuthConf(token).headers,
        'Content-Type': 'application/json'
      }
    };

    if (download) {
      config.responseType = 'blob';
    }

    return network
      .post(
        `${routes.REPORTS}/dashboard/averagescore${download ? '?download_csv=true':''}`,
        auditBody,
        config
      )
      .then(APINetCheck);
  },
  fetch_dashboard_location_ranking(token, fromDate,toDate,templateUuid,locationUuids,premisesGroupUuid) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid,
      premisesGroupUuid
    };

    return network
      .post(
        `${routes.REPORTS}/dashboard/location_performance`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },
  fetch_dashboard_daily_template_scores(token, fromDate,toDate,templateUuid,locationUuids,download) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid
    };

    return network
      .post(
        `${routes.REPORTS}/dashboard/daily_template_scores${download ? '?download_csv=true':''}`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },
  fetch_dashboard_section_performance(token, fromDate,toDate,templateUuid,locationUuids,download) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid
    };

    return network
      .post(
        `${routes.REPORTS}/dashboard/section_performance_aggregated${download ? '?download_csv=true':''}`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },
  fetch_dashboard_question_performance(token, fromDate,toDate,templateUuid,locationUuids,download) {
    APILog("Fetching a total audits data");

    const auditBody = {
      fromDate,
      toDate,
      locationUuids,
      templateUuid
    };

    return network
      .post(
        `${routes.REPORTS}/dashboard/question_performance_aggregated${download ? '?download_csv=true':''}`,
        auditBody,
        makeAuthConf(token)
      )
      .then(APINetCheck);
  },

};
